/**
 * Milo-style locale site keys → IETF tags (inverse used for detail page URL prefix).
 * Source: Adobe localization config; only `ietf` is required for prefix resolution.
 */
export const LOCALES_BY_SITE_KEY: Record<string, { ietf: string }> = {
  '': { ietf: 'en-US' },
  ae_ar: { ietf: 'ar' },
  ae_en: { ietf: 'en' },
  africa: { ietf: 'en' },
  ar: { ietf: 'es-AR' },
  at: { ietf: 'de-AT' },
  au: { ietf: 'en-AU' },
  be_en: { ietf: 'en-BE' },
  be_fr: { ietf: 'fr-BE' },
  be_nl: { ietf: 'nl-BE' },
  bg: { ietf: 'bg-BG' },
  br: { ietf: 'pt-BR' },
  ca_fr: { ietf: 'fr-CA' },
  ca: { ietf: 'en-CA' },
  ch_de: { ietf: 'de-CH' },
  ch_fr: { ietf: 'fr-CH' },
  ch_it: { ietf: 'it-CH' },
  cl: { ietf: 'es-CL' },
  cn: { ietf: 'zh-CN' },
  co: { ietf: 'es-CO' },
  cr: { ietf: 'es-419' },
  cy_en: { ietf: 'en-CY' },
  cz: { ietf: 'cs-CZ' },
  de: { ietf: 'de-DE' },
  dk: { ietf: 'da-DK' },
  ec: { ietf: 'es-419' },
  ee: { ietf: 'et-EE' },
  eg_ar: { ietf: 'ar' },
  eg_en: { ietf: 'en-GB' },
  el: { ietf: 'el' },
  es: { ietf: 'es-ES' },
  fi: { ietf: 'fi-FI' },
  fr: { ietf: 'fr-FR' },
  gr_el: { ietf: 'el' },
  gr_en: { ietf: 'en-GR' },
  gt: { ietf: 'es-419' },
  hk_en: { ietf: 'en-HK' },
  hk_zh: { ietf: 'zh-HK' },
  hu: { ietf: 'hu-HU' },
  id_en: { ietf: 'en' },
  id_id: { ietf: 'id' },
  ie: { ietf: 'en-GB' },
  il_en: { ietf: 'en-IL' },
  il_he: { ietf: 'he' },
  in_hi: { ietf: 'hi' },
  in: { ietf: 'en-IN' },
  it: { ietf: 'it-IT' },
  jp: { ietf: 'ja-JP' },
  kr: { ietf: 'ko-KR' },
  kw_ar: { ietf: 'ar' },
  kw_en: { ietf: 'en-GB' },
  la: { ietf: 'es-LA' },
  langstore: { ietf: 'en-US' },
  lt: { ietf: 'lt-LT' },
  lu_de: { ietf: 'de-LU' },
  lu_en: { ietf: 'en-LU' },
  lu_fr: { ietf: 'fr-LU' },
  lv: { ietf: 'lv-LV' },
  mena_ar: { ietf: 'ar' },
  mena_en: { ietf: 'en' },
  mt: { ietf: 'en-MT' },
  mx: { ietf: 'es-MX' },
  my_en: { ietf: 'en-GB' },
  my_ms: { ietf: 'ms' },
  ng: { ietf: 'en-GB' },
  nl: { ietf: 'nl-NL' },
  no: { ietf: 'no-NO' },
  nz: { ietf: 'en-GB' },
  pe: { ietf: 'es-PE' },
  ph_en: { ietf: 'en' },
  ph_fil: { ietf: 'fil-PH' },
  pl: { ietf: 'pl-PL' },
  pr: { ietf: 'es-419' },
  pt: { ietf: 'pt-PT' },
  qa_ar: { ietf: 'ar' },
  qa_en: { ietf: 'en-GB' },
  ro: { ietf: 'ro-RO' },
  ru: { ietf: 'ru-RU' },
  sa_ar: { ietf: 'ar' },
  sa_en: { ietf: 'en' },
  se: { ietf: 'sv-SE' },
  sg: { ietf: 'en-SG' },
  si: { ietf: 'sl-SI' },
  sk: { ietf: 'sk-SK' },
  th_en: { ietf: 'en' },
  th_th: { ietf: 'th' },
  tr: { ietf: 'tr-TR' },
  tw: { ietf: 'zh-TW' },
  ua: { ietf: 'uk-UA' },
  uk: { ietf: 'en-GB' },
  vn_en: { ietf: 'en-GB' },
  vn_vi: { ietf: 'vi' },
  za: { ietf: 'en-GB' },
}
